import React from 'react';
import { Form } from 'react-bootstrap';

import { SCREENSHOT_DEVICE_IDS } from './screenshotDevices';

const ScreenshotDeviceSelect = ({ value, onChange, className }) => (
  <Form.Group controlId="screenshotDevice" className={className}>
    <Form.Control as="select" size="sm" value={value} onChange={(e) => onChange(e.target.value)}>
      {SCREENSHOT_DEVICE_IDS.map((id) => (
        <option key={id} value={id}>{id}</option>
      ))}
    </Form.Control>
  </Form.Group>
);

export default ScreenshotDeviceSelect;
